<template>
    <div>
        <el-row class="video-tree flex" >

            <el-col :span="treespan"   :style="{height: tableHeight+100+'px',minWidth: '300px',overflowY: 'auto'}">
                <div class="ps-re">
                    <el-select  style="width: 100px"  class="usebutton" v-model="isuse" size="mini"  @change="refreshTree">
                        <el-option v-for="item in isuseList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                        </el-option>
                    </el-select>
                    <div class="fitW">
                        <el-tree ref="tree" :data="treeData" lazy :key="treeId" :load="loadNode" :props="defaultProps"
                                 node-key="i_id" @node-click="handleNodeClick" :default-expanded-keys="[0]"
                                 class="trees  video-tree height100" accordion :highlight-current='true'
                                 :expand-on-click-node="false" :show-checkbox="false">
                            <div class="custom-tree-node" style="width: 100%"  slot-scope="{ node, data }">
                            <span @contextmenu="showMenuFun($event,node, data)">
                                    <span style="font-size: 14px">{{ node.label }}</span>
                                <div v-if="showMenuId==data.i_id" class="menu"  style="z-index: 2">
                                    <template>
                                        <div  class="info" v-if="data.i_id==0&&data.i_level==0"  @click.stop="addTypeFun(data,'add')"><i class="el-icon-folder-add" style="margin-right: 8px; transform: rotate(90deg)"></i>{{addMenu}}</div>
                                        <div  class="info" v-if="data.i_id&&data.i_id!=0" @click.stop="addTypeFun(data,'edit')" ><i class="el-icon-edit" style="padding-right: 8px"></i>{{editMenu}}</div>
                                    </template>
                                </div>
                            </span>
                            </div>
                        </el-tree>
                    </div>
                </div>
            </el-col>
            <el-col :span="rightspan" id="tabelBox" style="height: 100%;min-width: 320px;width: 100%">
<!--                <el-button type="text" :class="[baseerp+'color','nopadding']"   @click="isright=!isright"  :icon="isright?'el-icon-s-fold':'el-icon-s-unfold'"></el-button>-->
                <div class="flex jcbc p14-9">
<!--                    <el-select v-if="chooseNode&&chooseNode.i_id==30" filterable size="mini">-->
<!--                        <el-option v-for="item in unitGroupList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>-->
<!--                    </el-select>-->
                    <div class="flex">
                        <el-input  class="marr4" style=""  v-model="vc_search" placeholder="请输入" clearable size="mini"></el-input>
                        <el-button class="marr4" icon="el-icon-search" circle  @click="searchFun" size="mini"></el-button>
                    </div>
                    <el-button class="marB10" v-if="chooseNode&&chooseNode.isLeaf"  @click="addFun(chooseNode,'add')" :class="baseerp+'btn'" size="mini">新增</el-button>
                </div>
                <el-table class="mrt10" ref="table" v-if="chooseNode&&chooseNode.i_id" size="mini" :height="tableHeight" border :data="tableData" :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true" style="width: 100%">
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column type="index" label="序号"></el-table-column>

                    <!--                    <el-table-column   prop="i_id" label="字典ID"  align="center"/>-->
<!--                    <el-table-column   prop="vc_name" label="名称"  align="center"/>-->
<!--                    <el-table-column   prop="vc_name_en" label="英文名称"  align="center"/>-->
                        <el-table-column v-for="column in filteredColumns" :key="column.prop" :prop="column.prop"
                                :label="column.label" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <template v-if="column.type==='select'">
                                    <span v-if="column.prop === 'i_isweightunit'">
                                    {{scope.row[column.prop]&&weightunitList.find(w=>w.i_id==scope.row[column.prop])?weightunitList.find(w=>w.i_id==scope.row[column.prop]).vc_name:''}}
<!--                                    {{weightunitList.find(w=>w.i_id==scope.row[column.prop])?.vc_name||''}}-->
                                    </span>
                                    <span v-else-if="column.prop === 'i_unitgroup_id'">
                                     {{scope.row[column.prop]&&unitGroupList.find(w=>w.i_id==scope.row[column.prop])?unitGroupList.find(w=>w.i_id==scope.row[column.prop]).vc_name:''}}
<!--                                     {{unitGroupList.find(w=>w.i_id==scope.row[column.prop])?.vc_name||''}}-->
                                    </span>
                                </template>
                                <template v-else-if="column.type==='radio'">
                                    <span>{{ scope.row[column.prop]==1 ? '是' : '否' }}</span>
                                </template>
                                <template v-else>
<!--                                    <span v-if="column.prop==='vc_baseunit_name'">-->
<!--                                        {{unitGroupList.find(w=>w.i_id==scope.row.i_unitgroup_id)?unitGroupList.find(w=>w.i_id==scope.row.i_unitgroup_id).vc_baseunit_name:''}}-->
<!--                                    </span>-->
                                    <span >{{ scope.row[column.prop]}}</span>
                                </template>
                            </template>
                        </el-table-column>
                    <el-table-column label="操作" width="60" align="center">
                        <template slot-scope="scope">
                            <el-button  size="mini" type="text" @click="addFun(scope.row,'edit')" >详情</el-button>
                        </template>
                    </el-table-column>

                </el-table>
                <el-pagination v-if="chooseNode&&chooseNode.i_id" style="margin-top: 10px;text-align: right" background @current-change="pageCurrentChange" layout="total,prev, pager, next"
                                :current-page.sync="currentPage" :total="total" :page-size="pageSize">
                </el-pagination>
            </el-col>
        </el-row>
        <div :class="baseerp+'div'">
            <el-dialog :title="addTitle" :width="chooseNode&&chooseNode.i_type==31||chooseNode&&chooseNode.i_type==3?'800px':'500px'"  :visible.sync="addVisible"
                       :top="chooseNode&&chooseNode.i_type==31?'30px':'150px'"
                       :close-on-click-modal="false" @close="closeAddFun">
                <add-page :data="addProp" v-if="addVisible" @close="closeAddFun"></add-page>
            </el-dialog>
            <el-dialog :title="addTypeTitle" width="500px"  :visible.sync="addTypeVisible"
                       :close-on-click-modal="false" @close="closeAddTypeFun">
                <add-type :data="addTypeProp" v-if="addTypeVisible" @close="closeAddTypeFun"></add-type>
            </el-dialog>

        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp, baseApp, file_url, baseVersion} from "@/utils/baseUrl";
    import AddPage from "./AddPage";
    import AddType from "./AddType";

    export default {
        name: "index",
        components: {AddPage,AddType},
        props: {},
        data() {
            return {
                tableHeight: 0,
                baseerp: '',
                defaultProps: {
                    children: 'children',
                    label: 'label',
                    isLeaf: 'isLeaf',
                    value:'i_id'
                },
                isuse:1,
                treeData:[{i_id:0,i_level:1,i_pid:0,label:'全部',children:[],isLeaf:false}],
                treeId:0,
                showMenuId:null,
                isuseList:[{i_id:1,vc_name:'启用'},{i_id:0,vc_name:'未启用'}],
                treespan:4,
                rightspan:20,
                canEdit:false,
                tableData:[],
                allColumns:[],
                dataText:this.$t('tips_no_data_available_at_the_moment'),
                addProp:{},
                addTitle:'',
                addTypeProp:{},
                addTypeTitle:'',
                addVisible:false,
                addTypeVisible:false,
                addMenu:'',
                editMenu:'',
                chooseNode:null,
                currentPage:1,
                pageSize:20,
                total:0,
                vc_search:'',
                weightunitList:[{i_id:0,vc_name:''},{i_id:1,vc_name:'重量单位'},{i_id:2,vc_name:'面积单位'},{i_id:3,vc_name:'体积单位'},{i_id:4,vc_name:'长度单位'},{i_id:5,vc_name:'计件'},],
                unitGroupList:[],
            }
        },
        computed: {
            filteredColumns() {
                // let arr=this.chooseNode&&this.chooseNode.dynamicColumn||[];
                let arr=[],publicArr=[{label:'名称',prop:'vc_name',required:true,type:'input'},{label:'英文名称',prop:'vc_name_en',required:true,type:'input'},];
                    // {label:'字典类型',prop:'i_type'},
                if(this.chooseNode&&this.chooseNode.i_type==3){
                    arr=[
                        {label:'拼写',prop:'vc_spell',required:true,type:'input'},
                        {label:'符号',prop:'vc_ename',required:true,type:'input'},
                        {label:'简写',prop:'vc_sname',required:true,type:'input'},
                        {label:'展示名称',prop:'vc_showname',required:true,type:'input'},
                        {label:'币种ICON',prop:'vc_path_bz',required:true,type:'input'},
                        {label:'是否用于国外订单',prop:'c_ordertype',required:true,type:'radio'},
                        {label:'兑换比例',prop:'i_hlnum',required:true,type:'input-num',min:1},
                    ];
                }else if(this.chooseNode&&this.chooseNode.i_type==2){
                    arr=[
                        {label:'费用编码',prop:'i_fyid',required:true,type:'input-num',min:0},
                        {label:'费用父编码',prop:'i_fypid',required:true,type:'input-num',min:0},
                        {label:'用友编码',prop:'vc_fymx_yycode',required:true,type:'input-num',min:0},
                    ];
                }else if(this.chooseNode&&this.chooseNode.i_type==31){
                    arr=[
                        {label:'是否件重单位',prop:'i_isweightunit',required:true,type:'radio'},
                        {label:'单位复数',prop:'vc_unitplural',required:true,type:'input'},
                        // {label:'单位组',prop:'i_unitgroup_id',required:true,type:'select'},
                        // {label:'是否基准单位',prop:'i_isbaseunit',required:true,type:'radio'},
                        // {label:'基准单位',prop:'vc_baseunit_name',required:true},
                        // {label:'基准单位转换率',prop:'f_baseunit_convertion',required:true,type:'input'},
                        {label:'精度',prop:'i_precision',required:true,type:'input-num',min:0},
                    ];
                }

                // console.log(arr)
                return this.allColumns= [...publicArr,...arr]
            }
        },
        watch: {
            '$root.workSize': {
                handler(n, o) {
                    this.onResize(n);
                },
                deep: true,
            },
        },
        activated() {
            this.onResize();
        },
        mounted() {
            this.baseerp = baseerp;
            this.$nextTick(() => {
                this.onResize();
            });
            this.getUnitGroupList()
            let that=this,box=document.getElementById('tabelBox');
            box.addEventListener('mouseup',function (event) {
                if(event.button===0||event.button==2){
                    // console.log('down------------------')
                    that.showMenuId=null

                }
            })
        },
        methods: {
            onResize(n) {
                if (n == undefined) n = this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight = n.h - (n.h) * 0.3+100;
                if (this.tableHeight < 60) this.tableHeight = 60;
            },
            refreshTree(){
                this.treeId=Math.random();
            },
            showMenuFun(event,node, val){
                // console.log( data,'val')
                event.preventDefault();
                this.showMenuId=val.i_id;
                    if(val.i_id==0&&val.i_level==0) {
                        this.addMenu = '新增类型'
                    }else if(val.i_id){
                        this.editMenu='编辑'
                    }

            },
            addFun(val,type){
                this.addVisible=true;
                if(type=='add'){
                    this.addTitle='新增项';
                    this.addProp={
                        dynamicColumn:this.allColumns,
                        type:type,
                        data:this.chooseNode
                    };
                }else if(type=='edit'){
                    this.addTitle='编辑'+val.vc_name;
                    this.addProp={
                        dynamicColumn:this.allColumns,
                        type:type,
                        data:{vc_type:this.chooseNode.vc_name,...val}
                    };
                }

            },
            closeAddFun(type='close'){
                this.addVisible=false
                if(type=='save'){
                    this.currentPage=1
                    this.getItemList()
                }
            },
            addTypeFun(val,type){
                let data=JSON.parse(JSON.stringify(val));
                this.addTypeVisible=true;
                if(type=='add'){
                    if(val.i_id==0&&val.i_level==0) {
                        this.addTypeTitle = '新增类型'
                    }
                }else if(type=='edit'){
                    if(val.i_id&&val.i_level==0){
                        this.addTypeTitle='编辑类型'
                    }
                }
                this.addTypeProp={
                    data:data,
                    type:type
                };
                this.showMenuId=null;

            },
            closeAddTypeFun(type='close'){
                this.addTypeVisible=false
                if(type=='save'){
                    this.refreshTree()
                }
            },
            
            handleNodeClick(val){
                // console.log('val',val)
                this.showMenuId=null;
                if(val.i_id){
                    let data=JSON.parse(JSON.stringify(val));
                    this.chooseNode=data
                    this.vc_search=''
                    this.tableData=[]
                    this.currentPage=1
                    this.getItemList()
                }else{
                    this.chooseNode=null
                    this.tableData=[]
                }
                // this.$emit('showData',data)
            },
            loadNode(node, resolve) {
                this.showMenuId=null;
                let _this=this;
                if (node.level === 0) {
                    let val={i_id:0,i_level:0,i_pid:0,label:'全部',vc_name:'全部',children:[],childProduct:0,isLeaf:false};
                    return resolve([val]);
                }
                if (node.level>=1&&node.data.isLeaf==false){
                    _this.getItemTypeList(node.data,resolve,node.level);
                }
            },
            async getItemTypeList({i_id=0,type=0},resolve,level){
                let param = {
                    i_pid:i_id,
                    isuse:this.isuse,
                };
                let res = await API.getItemTypeList(param);
                if (res.code == 1) {
                    let list=[];
                    if (res.data.length>0){
                        res.data.map(one=>{
                            let hash=one;
                            hash.isLeaf=true;
                            hash.i_level= one.i_level;
                            hash.label= one.vc_name;
                            list.push(hash);
                        })
                    }
                    return resolve(list);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            searchFun(){
                this.currentPage=1
                this.getItemList()
            },
            pageCurrentChange(val){
                this.currentPage=val;
                this.getItemList()
            },
            async getItemList(){
                let param = {
                    vc_search:this.vc_search,
                    i_type:this.chooseNode.i_type,
                    isuse:this.isuse,
                    pageSize: this.pageSize,
                    currentPage:this.currentPage
                };
                let res = await API.getItemList(param);
                if (res.code == 1) {
                    this.tableData=res.data.items;
                    this.total=res.data.count
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async getUnitGroupList(){
                let param={
                    i_isuse:1,
                    vc_search:'',
                    pageSize: 50,
                    currentPage:1
                };
                let res=await API.getUnitGroupList(param);
                if ( res.code == 1 ){
                    this.unitGroupList=res.data.list;
                    this.total=res.data.total;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display: flex;
    }
    .jcbc{
        justify-content: space-between;
    }
    .fitW{
        width: fit-content;
    }
    .ps-re{
        position: relative;

    }
    .usebutton{
        position: absolute;
        right: 0;
        top: 0;
        z-index: 99;
    }
    /deep/ {
        .el-tree-node__label {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .el-tree-node__content{
            width: 100%;
        }
    }
    .menu{
        /*display: flex;*/
        border: 1px solid #8e8e8e;
        right: 0;
        position: absolute;
        background-color: #fff;
        box-shadow:0 2px 8px rgba(0,0,0,0.1);
    }
    .info{
        /*border: 1px solid #8e8e8e;*/
        padding: 5px 15px;
        font-size: 14px;
    }
    .info:hover{
        background-color: #CCCCCC;

    }
    .el-tree span{
        display: inline-block;
        width: 100%;
    }
    .jian{
        background-color: #409EFF ;
    }
    .zhi{
        background-color: #ff0500;
    }
    .ziicon{
        display: inline-block;
        /*padding:3px 4px;*/
        border-radius: 4px;
        border: 1px;
        color: white;
        width: 20px !important;
        height: 19px;
        line-height: 19px;
        font-size: 12px;
        margin:0 4px;
        text-align: center;
    }
    .p14-9{
        padding: 14px 9px;
    }
</style>